import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'react-mdl'
import Button from '../components/Button'
import { withRouter } from 'react-router-dom'
import { provideState, injectState, softUpdate } from 'freactal'
import { pure } from '../utils'
import app from '../feathers'

const withState = provideState({
  initialState: () => ({
    errorReported: false,
  }),
  effects: {
    setErrorReported: softUpdate((_, errorReported) => ({ errorReported })),
    reportError: pure(
      async (effects, _, { errorContext = {}, error, prompt, location }) => {
        const { action, output } = await prompt({
          title: 'Report Error',
          message: 'Fill out a description of the error you have experienced.',
          inputs: [
            {
              type: 'text',
              label: 'Description',
              name: 'description',
            },
          ],
          options: ['Send Error Report'],
        })
        if (action === 'Send Error Report' && output.description) {
          effects.setErrorReported('loading')
          await app.service('error-reports').create({
            description: output.description,
            context: {
              ...errorContext,
              path: location.pathname,
              errorMessage: error.message,
              errorStack: error.stack,
            },
          })
          effects.setErrorReported(true)
        }
      },
    ),
  },
})
ReportErrorButton.contextTypes = {
  prompt: PropTypes.func,
}

export default withState(injectState(withRouter(ReportErrorButton)))

function ReportErrorButton(
  { effects, state: { errorReported }, error, location, errorContext },
  { prompt },
) {
  return (
    <Button
      onClick={() =>
        !errorReported &&
        effects.reportError({ error, prompt, location, errorContext })}>
      {errorReported
        ? errorReported === 'loading' ? <Spinner /> : 'Error reported.'
        : 'Report Error'}
    </Button>
  )
}



// WEBPACK FOOTER //
// ./src/components/ReportErrorButton.js